import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import Icon from "../../assets/Icon";
import { Container } from './styles';

type Props = {
    onRight?: () => void;
};

const ArrowRight: React.FC<Props> = ({ onRight }) => {

    const theme = useContext(ThemeContext)
    return (
        <Container onClick={onRight}>
            <Icon icon={'Arrow_right'} size={50} color={theme.colors.background} />
        </Container>
    );
};

export default ArrowRight;